var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "banner-mt-link" },
    [
      _setup.isMobile
        ? _c(
            "div",
            {
              staticClass:
                "banner-mt-link__strip banner-mt-link__strip--stacked",
              on: { click: _setup.openModal },
            },
            [
              _c("div", [
                _c("img", {
                  staticClass:
                    "banner-mt-link__logo banner-mt-link__logo--stacked",
                  attrs: {
                    src: _setup.logoSrc,
                    alt: _setup.translate("Логотип МедТочки"),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-body-2" }, [
                  _vm._v("\n        " + _vm._s(_vm.text) + "\n      "),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "banner-mt-link__strip",
              on: { click: _setup.openModal },
            },
            [
              _c("img", {
                staticClass: "banner-mt-link__logo mr-8",
                attrs: {
                  src: _setup.logoSrc,
                  alt: _setup.translate("Логотип МедТочки"),
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-body-2 mr-3" }, [
                _vm._v("\n      " + _vm._s(_vm.text) + "\n    "),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "ui-icon-circle-info ml-auto" }),
            ]
          ),
      _vm._v(" "),
      _setup.isOpened
        ? _c(_setup.BannerMtLinkModal, {
            on: {
              close: function ($event) {
                _setup.isOpened = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "ml-3" }, [
      _c("span", { staticClass: "ui-icon-circle-info" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }